const TagButton = ({ 
  disconnectText, 
  tag, 
  showExitModal, 
  sidebarOpen, 
  showSummaryModal, 
  showActionPlanModal, 
  showSmartHabitModal,
  setShowSummaryModal,
  setShowActionPlanModal,
  setShowSmartHabitModal
}) => {
  if (!disconnectText || !tag) return null;
  
  const handleClick = () => {
    if (tag === "action_item") {
      setShowActionPlanModal(true);
    } else if (tag === "smart_habit") {
      setShowSmartHabitModal(true);
    } else {
      setShowSummaryModal(true);
    }
  };
  
  const buttonText = tag === "action_item" 
    ? "See my action plan" 
    : tag === "smart_habit" 
      ? "See my smart habit" 
      : "See the summary";
  
  return (
    <div
      className={`coaching-tag-button-container ${
        (showExitModal || sidebarOpen || showSummaryModal || showActionPlanModal || showSmartHabitModal) && 'exit'
      }`}
      onClick={handleClick}
    >
      {buttonText}
    </div>
  );
};

export default TagButton;
